import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import { Tooltip } from 'components/core/Tooltip';

import { Info } from 'components/svg';
import './FeeWarningToolTipV2.scss';

function FeeWarningToolTipV2({
	feeProps,
	className,
	triggerAlignment = 'center',
}) {
	const fees = [
		{ name: 'One-Time Admin Fee', price: feeProps?.admin?.value },
		{ name: 'One-Time Lock Fee', price: feeProps?.lock?.value },
	].filter((fee) => fee.price > 0);
	const totalFees = feeProps?.totalFees.value;
	return (
		<Tooltip
			content={
				<Text
					size="tiny"
					color="gray"
				>
					The following fees shall apply:
					{fees && (
						<ul>
							{fees.map((fee) => (
								<li key={fee.name}>
									{`${fee.name}: $${fee.price}`}
								</li>
							))}
						</ul>
					)}
				</Text>
			}
			clickOnMobile
			fillParentContainer={triggerAlignment}
			simpleButton
			as="div"
		>
			<Info />
			<Text
				last
				size="tiny"
				color="gray"
				className="total-fee-text"
				weight="standard"
			>
				<span>${totalFees} in fees</span>
			</Text>
		</Tooltip>
	);
}

FeeWarningToolTipV2.propTypes = {
	feeProps: PropTypes.object.isRequired,
	className: PropTypes.string,
	triggerAlignment: PropTypes.string,
};

export default FeeWarningToolTipV2;
